<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">汇算清缴报表</li>
      <el-button
        type="primary"
        :icon="Download"
        link
        @click="state.showAgent = true"
        v-if="$judge_auth('780')"
      >
        从税局更新数据
      </el-button>
    </ul>
    <ul class="c-list-search">
      <div>
        <li class="group-title" icon="*">所属年度</li>
        <el-date-picker
          v-model="state.params.year"
          type="year"
          placeholder="所属年度"
          format="YYYY年"
          :clearable="false"
          value-format="YYYY"
          style="width: 120px"
        />
      </div>
      <div>
        <li class="group-title">扣缴义务人</li>
        <div
          class="c-withholdingagent-search-box"
          @click="state.showWithholdingAgent = true"
        >
          <li style="flex: 1; display: flex; column-gap: 5px">
            <template v-if="state.withholding_agent_arr?.length > 0">
              <div
                class="c-withholdingagent-search-tag"
                style="
                  max-width: 200px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                {{ state.withholding_agent_arr[0]?.name }}
              </div>
              <el-popover
                v-if="state.withholding_agent_arr?.length > 1"
                placement="right"
                width="auto"
                popper-style="max-height: 90vh;overflow-y: auto;"
              >
                <template #reference>
                  <div class="c-withholdingagent-search-tag" @click.stop="">
                    {{ "+ " + (state.withholding_agent_arr?.length - 1) }}
                  </div>
                </template>
                <template #default>
                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      row-gap: 5px;
                      width: fit-content;
                    "
                  >
                    <ul
                      v-for="(item, index) in state.withholding_agent_arr"
                      :key="item"
                      style="
                        white-space: nowrap;
                        background-color: #f0f2f5;
                        color: var(--el-color-info);
                        border-radius: 4px;
                        font-size: 12px;
                        padding: 0 9px;
                        height: 24px;
                        line-height: 24px;
                        display: flex;
                        align-items: center;
                        column-gap: 10px;
                      "
                    >
                      <li>{{ item.name }}</li>
                      <el-icon
                        @click.stop="
                          state.withholding_agent_arr.splice(index, 1)
                        "
                        color="#a2a2a2"
                        style="cursor: pointer"
                        ><CircleClose
                      /></el-icon>
                    </ul>
                  </div>
                </template>
              </el-popover>
            </template>
            <text v-else style="color: #a2a2a2">点击选择扣缴义务人</text>
          </li>
          <el-icon
            v-if="state.withholding_agent_arr?.length > 0"
            @click.stop="delete state.withholding_agent_arr"
            color="#a2a2a2"
            ><CircleClose
          /></el-icon>
        </div>
      </div>
      <div>
        <li class="group-title">税款所属期</li>
        <c_statusradiogroup
          v-model="state.params.status"
          arrName="taxfinalsettlement_status"
          @change="onLoad"
        ></c_statusradiogroup>
      </div>
      <div>
        <li class="group-title" icon="*">是否需要人员申报</li>
        <el-radio-group
          v-model.number="state.params.sfrysb"
          :fill="state.params.sfrysb == 1 ? '#1e90ff' : '#a2a2a2'"
        >
          <el-radio-button :value="1">
            <text
              :style="{ color: state.params.sfrysb == 1 ? '#fff' : '#1e90ff' }"
            >
              是
            </text>
          </el-radio-button>
          <el-radio-button :value="0">
            <text
              :style="{ color: state.params.sfrysb == 0 ? '#fff' : '#a2a2a2' }"
            >
              否
            </text>
          </el-radio-button>
        </el-radio-group>
      </div>
      <div>
        <li class="group-title" icon="*">是否获取所有员工</li>
        <el-radio-group
          v-model.number="state.params.is_all"
          :fill="state.params.is_all == 1 ? '#1e90ff' : '#a2a2a2'"
        >
          <el-radio-button :value="1">
            <text
              :style="{ color: state.params.is_all == 1 ? '#fff' : '#1e90ff' }"
            >
              是
            </text>
          </el-radio-button>
          <el-radio-button :value="0">
            <text
              :style="{ color: state.params.is_all == 0 ? '#fff' : '#a2a2a2' }"
            >
              否
            </text>
          </el-radio-button>
        </el-radio-group>
      </div>
      <div>
        <li class="group-title" icon="*">是否是测一测</li>
        <el-radio-group
          v-model.number="state.params.is_scan"
          :fill="state.params.is_scan == 1 ? '#1e90ff' : '#a2a2a2'"
        >
          <el-radio-button :value="1">
            <text
              :style="{ color: state.params.is_scan == 1 ? '#fff' : '#1e90ff' }"
            >
              是
            </text>
          </el-radio-button>
          <el-radio-button :value="0">
            <text
              :style="{ color: state.params.is_scan == 0 ? '#fff' : '#a2a2a2' }"
            >
              否
            </text>
          </el-radio-button>
        </el-radio-group>
      </div>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        @row-click="onRowClick"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          label="扣缴义务人名称"
          prop="withholding_agent_name"
          width="120"
          align="center"
        />
        <el-table-column label="税局" prop="tax_bureau_name" align="center" />
        <el-table-column label="更新状态" prop="get_status">
          <template #default="{ row }">
            <c_status
              arr-name="taxfinalsettlement_status"
              :value="row.get_status"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="更新时间"
          prop="get_response_time"
          align="center"
        />
        <el-table-column label="人员数" prop="employee_num" align="center" />
        <el-table-column
          label="已汇算清缴人数"
          prop="deal_num"
          align="center"
        />
        <el-table-column
          label="未汇算清缴人数"
          prop="un_deal_num"
          align="center"
        />
        <el-table-column label="外管证编号" prop="biz_no" align="center" />
        <el-table-column label="税局备案部门编号" prop="bmbh" align="center" />
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template #default="{ row }">
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
              "
            >
              <el-button
                type="primary"
                link
                icon="View"
                @click="
                  $store.commit('openMenu', {
                    path: 'TaxFinalSettlementDetail',
                    title: '汇算清缴详情',
                    refresh: true,
                    data: {
                      id: row.id,
                      title:
                        row.withholding_agent_name +
                        '-' +
                        state.params.year +
                        '年度汇算清缴详情',
                    },
                  })
                "
                style="margin-left: 0"
              >
                查看
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showWithholdingAgent"
        title="选择扣缴义务人"
        @close="state.showWithholdingAgent = false"
      >
        <c_WithholdingAgentSelect
          @close="
            (arr) => {
              state.withholding_agent_arr = arr;
              state.showWithholdingAgent = false;
            }
          "
          :selectItems="state.withholding_agent_arr"
        ></c_WithholdingAgentSelect>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showAgent"
        title="从税局更新汇算清缴"
        @close="state.showAgent = false"
      >
        <c_Agent
          :year="state.params.year"
          v-if="state.showAgent"
          @close="state.showAgent = false"
          @confirm="onSelectConfirm"
        ></c_Agent>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  taxfinalsettlement_list,
  taxfinalsettlement_export,
} from "@/http/taxfinalsettlement";
import { dayjs, ElMessage } from "element-plus";
import { income_select } from "@/http/dictionary";
import { data_customer_select } from "@/http/data";

import c_Agent from "./SelectWithholdingAgent.vue";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sfrysb: 1,
    is_all: 0,
    is_scan: 0,
  };
}
export default {
  components: {
    c_Agent,
  },
  setup() {
    const state = reactive({
      ...new InitFormData(),
      tableData: [],
    });
    onMounted(() => {
      state.params.year = dayjs().subtract(1, "year").format("YYYY");
      onLoadIncome();
      onLoadCustomer();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      if (state.withholding_agent_arr?.length > 0)
        state.params.withholding_agent_id = state.withholding_agent_arr
          ?.map((m) => m.id)
          .join(",");
      else delete state.params.withholding_agent_id;

      if (state.tax_month?.length > 0)
        state.params.tax_month = state.tax_month.join(" - ");
      else delete state.params.tax_month;

      taxfinalsettlement_list(state.params)
        .then((res) => {
          if (res.status == 200) {
            const { count, list, sortFields } = res.data.data;
            state.totalCount = count;
            state.tableData = list;
            state.sortFields = sortFields;
          } else {
            state.totalCount = 0;
            state.tableData = [];
            ElMessage.error(res.data.msg);
          }
        })
        .catch((err) => {
          state.totalCount = 0;
          state.tableData = [];
          ElMessage.error(err.data.msg);
        });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      state.params.tax_month = dayjs().subtract(1, "month").format("YYYY-MM");
      onLoad();
    };

    //获取所得项目
    const onLoadIncome = () => {
      income_select().then((res) => {
        if (res.status == 200) state.incomeData = res.data.data;
      });
    };

    const onExport = () => {
      let params = JSON.parse(JSON.stringify(state.params));
      params.limit = 0;
      taxfinalsettlement_export(params)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1],
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8",
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onExport,
      onLoadIncome,
      onLoadCustomer,
    };
  },
};
</script>
<style scoped></style>
